import {
  APP_SETTING_GET_ALL_TRACKING_ACTIVITY_BEGIN,
  APP_SETTING_GET_ALL_TRACKING_ACTIVITY_SUCCESS,
  APP_SETTING_GET_ALL_TRACKING_ACTIVITY_FAILURE,
  APP_SETTING_GET_ALL_TRACKING_ACTIVITY_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function getAllTrackingActivity(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_GET_ALL_TRACKING_ACTIVITY_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/tracking/${projectId}`;
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_GET_ALL_TRACKING_ACTIVITY_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: APP_SETTING_GET_ALL_TRACKING_ACTIVITY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetAllTrackingActivityError() {
  return {
    type: APP_SETTING_GET_ALL_TRACKING_ACTIVITY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_GET_ALL_TRACKING_ACTIVITY_BEGIN:
      return {
        ...state,
        getAllTrackingActivityPending: true,
        getAllTrackingActivityError: null,
      };

    case APP_SETTING_GET_ALL_TRACKING_ACTIVITY_SUCCESS:
      return {
        ...state,
        getAllTrackingActivityPending: false,
        getAllTrackingActivityError: null,
        allActivity: action.data.data,
      };

    case APP_SETTING_GET_ALL_TRACKING_ACTIVITY_FAILURE:
      return {
        ...state,
        getAllTrackingActivityPending: false,
        getAllTrackingActivityError: action.data.error,
      };

    case APP_SETTING_GET_ALL_TRACKING_ACTIVITY_DISMISS_ERROR:
      return {
        ...state,
        getAllTrackingActivityError: null,
      };
    default:
      return state;
  }
}
